import {
  QuickGuideContent,
  SUB_TABS,
  TOP_TABS,
  Typography,
  type TopTab,
} from '@dreamteam-monorepo/ui';
import { ContentAdSlot } from '@/ads';
import { trackFantasyGa4Event } from '@/hooks/useGa4Tracking';

const sectionId = (topTab: TopTab, subTab: string) => `${topTab}-${subTab}`;

export const HowToPlay = () => {
  return (
    <div className="components light flex flex-col bg-white">
      <section className="bg-[--page-header-bg-grey]">
        <div className="mx-auto flex w-full max-w-[846px] flex-col gap-[--padding-sm] px-[--padding-md] py-[--padding-xl] sm:px-0">
          <Typography
            as="h1"
            variant="headline050"
            className="text-[--page-header-header] !font-[900] sm:text-40 sm:leading-44"
          >
            HOW TO PLAY
          </Typography>
          <Typography
            as="p"
            variant="subheadline030"
            className="max-w-[680px] text-[--page-header-header]"
          >
            Season Fantasy Game rules, scoring, transfers, Boosters and mini league details.
          </Typography>
        </div>
      </section>

      <main className="mx-auto grid w-full max-w-[1120px] grid-cols-1 gap-[--padding-xl] px-[--padding-md] py-[--padding-xl] lg:grid-cols-[240px_minmax(0,1fr)]">
        <nav
          aria-label="How to play sections"
          className="min-w-0 lg:sticky lg:top-[--padding-xl] lg:self-start"
        >
          <div className="hidden flex-col gap-[--padding-md] rounded-[--corner-xs] border border-[#eae9fd] bg-white p-[--padding-md] lg:flex">
            {TOP_TABS.map(topTab => (
              <div key={topTab.id} className="flex flex-col gap-[--padding-xs]">
                <Typography as="p" variant="label020" className="text-[--color-neutral-900]">
                  {topTab.label}
                </Typography>
                <div className="flex flex-col gap-1">
                  {SUB_TABS[topTab.id].map(subTab => (
                    <a
                      key={subTab.id}
                      href={`#${sectionId(topTab.id, subTab.id)}`}
                      onClick={() =>
                        trackFantasyGa4Event('rules', {
                          eventCategory: 'FF - How to Play',
                          eventLabel: `Text link - ${subTab.label}`,
                        })
                      }
                      className="rounded-[--corner-xs] px-2 py-1 text-sm font-bold text-[#0072ee] hover:bg-[#f8f8ff] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#030033]"
                    >
                      {subTab.label}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="flex max-w-full gap-2 overflow-x-auto pb-1 lg:hidden">
            {TOP_TABS.flatMap(topTab =>
              SUB_TABS[topTab.id].map(subTab => (
                <a
                  key={`${topTab.id}-${subTab.id}`}
                  href={`#${sectionId(topTab.id, subTab.id)}`}
                  onClick={() =>
                    trackFantasyGa4Event('rules', {
                      eventCategory: 'FF - How to Play',
                      eventLabel: `Text link - ${subTab.label}`,
                    })
                  }
                  className="flex h-10 shrink-0 items-center rounded-full border-2 border-[#eae9fd] bg-white px-4 text-sm font-bold text-[#222526]"
                >
                  {subTab.label}
                </a>
              ))
            )}
          </div>
        </nav>

        <div className="flex min-w-0 flex-col gap-[--padding-2xl]">
          {TOP_TABS.map(topTab => (
            <section key={topTab.id} className="flex flex-col gap-[--padding-md]">
              <Typography
                as="h2"
                variant="headline030"
                className="text-[--color-neutral-900] !font-[900]"
              >
                {topTab.label}
              </Typography>

              <div className="flex flex-col gap-[--padding-md]">
                {SUB_TABS[topTab.id].map(subTab => (
                  <section
                    key={subTab.id}
                    id={sectionId(topTab.id, subTab.id)}
                    className="scroll-mt-[--padding-xl] rounded-[--corner-xs] border border-[#eae9fd] bg-white p-[--padding-md]"
                  >
                    <div className="flex flex-col gap-[--padding-md]">
                      <Typography
                        as="h3"
                        variant="label030"
                        className="text-[--color-neutral-900] !font-[800]"
                      >
                        {subTab.label}
                      </Typography>
                      <QuickGuideContent topTab={topTab.id} subTab={subTab.id} />
                    </div>
                  </section>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>
      <ContentAdSlot id="ad-boa-leaderboard" />
    </div>
  );
};
